import {api} from "../../system/api";

export default {
    fetchTemplateBagsLastmile: (params) => api.get('lastmile-bag-templates', {params}),
    fetchDetailTemplateBagsLastmile: (id) => api.get(`lastmile-bag-templates/${id}`, {}),
    createTemplateBagLastmile: (data) => api.post('lastmile-bag-templates', data),
    updateTemplateBagLastmile: (id, data) => api.put(`lastmile-bag-templates/${id}`, data),
}